import { gql } from 'apollo-angular';

const GET_OFFERS_PERMISSIONS = gql`
  query getOfferPermissions($rfpId: Long!) {
    offerPermissions(rfpId: $rfpId) {
      hasAccess
      permissionType
      reasonForDenial
    }
  }
`;

export default GET_OFFERS_PERMISSIONS;
